import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import FormInput from "../../../../common/forms/FormInput";
import BackBar from "../../../../common/nav/BackBar";

import { IconEsportsPersonSVG } from "../../../../assets/img/iconEsportsPersonSVG";
import { IconTeamOwnerSVG } from "../../../../assets/img/IconTeamOwnerSVG";
import { IconProjectSVG } from "../../../../assets/img/IconProjectSVG";
import { IconCalendarSVG } from "../../../../assets/img/iconCalendarSVG";
import { IconMailSVG } from "../../../../assets/img/IconMailSVG";

import styles from "./DeleteAccount.module.scss";
import { IconTopicsSVG } from "../../../../assets/img/IconTopicsSVG";
import { IconFacilitySVG } from "../../../../assets/img/facility/IconFacilitySVG";

type Props = {
  handleClose: () => void;
  isAgreement: boolean;
  setIsAgreement: (isAgreement: boolean) => void;
  handleSubmit: () => void;
};

const DeleteAccount: React.FC<Props> = ({
  handleClose,
  isAgreement,
  setIsAgreement,
  handleSubmit,
}) => {
  return (
    <>
      <BackBar
        title="アカウント削除"
        editable={false}
        handleClose={handleClose}
      />
      <div className={styles["f-delAccount"]}>
        <div className={styles["f-delAccount__head"]}>
          <FontAwesomeIcon icon={["fal", "exclamation-circle"]} />
          <p className={styles["f-delAccount__head-title"]}>
            SELeCTアカウントを削除しますか？
          </p>
          <p className={styles["f-delAccount__head-desc"]}>
            アカウントを削除すると保有しているコンテンツがすべて削除されます。
          </p>
        </div>
        <ul className={styles["f-delAccount__contents"]}>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconEsportsPersonSVG width={44.657} height={43.811} />
            </div>
            <span>プロフィール</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconTeamOwnerSVG width={44.657} height={43.811} />
            </div>
            <span>チーム</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconProjectSVG width={44.657} height={43.811} />
            </div>
            <span>プロジェクト</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconCalendarSVG width={42.657} height={44.811} />
            </div>
            <span>イベント</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconTopicsSVG width={42.657} height={44.811} />
            </div>
            <span>トピックス</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconFacilitySVG width={44.657} height={43.811} />
            </div>
            <span>eスポーツ施設</span>
          </li>
          <li className={styles["f-delAccount__contents-item"]}>
            <div>
              <IconMailSVG width={48.657} height={51.811} />
            </div>
            <span>オファーや応募</span>
          </li>
        </ul>
        <div className={styles["f-delAccount__agreement"]}>
          <FormInput
            type="checkbox"
            label=""
            id="checkbox"
            name="agreement"
            initial_value={isAgreement.toString()}
            handler={() => setIsAgreement(!isAgreement)}
          />
          <label htmlFor={"checkbox"}>
            全てのコンテンツが削除されることを理解しました
          </label>
        </div>
        <div className={styles["f-delAccount__btn"]}>
          <button
            type="button"
            className={
              isAgreement === true
                ? `${styles["f-delAccount__btn-delete"]} ${styles["agree"]}`
                : styles["f-delAccount__btn-delete"]
            }
            disabled={isAgreement === true ? false : true}
            onClick={handleSubmit}
          >
            アカウントを削除
          </button>
        </div>
        <div className={styles["f-delAccount__btn"]}>
          <button
            type="button"
            className={styles["f-delAccount__btn-cancel"]}
            onClick={handleClose}
          >
            キャンセル
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
